import {
  createTheme,
} from '@material-ui/core';

export const formLabelsTheme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#EB9937',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
  },
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: '#db3131',
        '&$error': {
          color: '#db3131',
        },
      },
    },
    '&.Mui-focused fieldset': {
      borderColor: '#C52328',
      borderWidth: '2px',
    },
  },
});

export const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      overflow: 'auto',
    },
  },
  input: {
    height: 40,
    [theme.breakpoints.up('300')]: {
      width: 130,
    },
    [theme.breakpoints.up('576')]: {
      width: 200,
    },
    [theme.breakpoints.up('768')]: {
      width: 130,
    },
    [theme.breakpoints.up('1024')]: {
      width: 160,
    },
    color: '#76787A',
    fontSize: '14px',
  },
  labelAsterisk: {
    color: 'red',
  },
  notchedOutline: {
    '&:focus': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
    },
  },
  focused: {
    borderColor: '#db3131',
  },
});

